import React, { useEffect } from 'react';

import './Header.scss';

import Text from '../../containers/Text';
import '../../languages/i18n';
import AppLogo from '../../shared/icons/logo2.png';

import useWindowDimensions from '../../hooks/windowResize';

import { GiHamburgerMenu } from 'react-icons/gi';
import { useHistory } from 'react-router-dom';
import { ActivePageService } from '../../services/active-page';

const Header = ({
  changeLanguage,
  setLanguage,
  user,
  handleDrawer,
  setActivePage,
}) => {
  const { screenWidth } = useWindowDimensions();
  const history = useHistory();

  useEffect(() => {
    const page = ActivePageService.getActivePageUrl(history.location.pathname);

    setActivePage(page);
  }, [history.location.pathname, setActivePage]);

  function redirectToHome() {
    history.push('/');
  }

  return (
    <div className={!user.id ? 'auth-header-container' : 'header-container'}>
      {user.id && (
        <div className="header-inner">
          <button
            onClick={handleDrawer}
            className="menu-button"
            aria-label="Toggle menu"
          >
            <GiHamburgerMenu className="nav-bar-icon" />
          </button>

          <div className="logo-wrapper">
            <Text
              text={
                <img
                  src={AppLogo}
                  onClick={redirectToHome}
                  className="mobile-app-logo"
                  alt="app logo"
                />
              }
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
